import isBrowser from './isBrowser';

declare global {
  interface Window {
    affirm: {
      ui: {
        ready: (callback: () => void) => void;
        refresh: () => void;
      };
    };
  }
}

const affirmRefresh = (): void => {
  if (isBrowser()) {
    window.affirm.ui.ready(() => {
      // refresh not being a function causes flakiness in Cypress tests
      if (typeof window.affirm.ui.refresh === 'function') {
        window.affirm.ui.refresh();
      }
    });
  }
};

export default affirmRefresh;
